<template>
  <div>
    <my-asidebar v-bind:active-tab="'seaTour'"> </my-asidebar>
    <section class="dashboard-area">
      <top-bar></top-bar>
      <div class="dashboard-content-wrap">
        <div class="dashboard-bread dashboard--bread dashboard-bread-2">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="breadcrumb-content">
                  <div class="section-heading">
                    <h2 class="sec__title font-size-30 text-white">Tur</h2>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="breadcrumb-list text-right">
                  <ul class="list-items">
                    <li><a :href="basePath" class="text-white">Anasayfa</a></li>
                    <li><a :href="basePath+'/seatours'" class="text-white">Tur</a></li>
                    <li>Detay</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <sea-tour-detail></sea-tour-detail>
      </div>
    </section>

  </div>
</template>

<script>
import SeaTourDetail from "../component/seatour/SeaTourDetail";
import TopBar from "../component/common/TopBar";
import MyAsidebar from "../component/common/MyAsidebar";

export default {
  name: "SeaTourDetailPage",
  components: {MyAsidebar, SeaTourDetail, TopBar},
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    panelRights: {
      get() {
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  beforeCreate() {
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_SEATOUR_DETAIL"]) this.$router.push("/");
    if(this.$route.params.id !== undefined && this.$route.params.id !== 'new') {
      this.$store.dispatch("loadSeaTour",this.$route.params.id)
      this.$store.dispatch("loadSeaTourRouteListBySeaTourId", this.$route.params.id)
    }else{
      this.$nextTick(()=>{
        this.$store.commit("setSeaTour",{id:-1,name : "", image:{},ports:[],visaRequired:false})
        this.$store.commit("setSeaTourRouteList",[])
      })
    }
    this.$store.dispatch("loadPortList");
  }
}
</script>

<style scoped>

</style>